<template>
  <el-select
    :disabled="disabled"
    :multiple="multiple"
    clearable
    filterable
    @change="handleChange"
    :value="data"
    placeholder="请选择"
  >
    <el-option
      :label="item.name"
      :value="item.name"
      v-for="(item, index) in cityList"
      :key="index"
    ></el-option>
  </el-select>
</template>

<script>
import { city } from "@/services/operation";

export default {
  name: "City",
  props: {
    value: {},
    province: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { data: [], cityList: [] };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    province: {
      immediate: true,
      handler(value) {
        // console.log(value)
        // let val = JSON.stringify(value)
        if (value && value.value) {
          this.loadData(value);
        } else {
          this.cityList = [];
           this.data=[];
        }
      },
    },
   value:{
      immediate: true,
      handler(value) {
          this.data=value;
      }
    }
  },
  methods: {
    handleChange(value) {       
        this.$emit("input",value);
        this.data=value;
    },
    async loadData(province) {
      this.cityList = [];
      this.data = [];
      this.$emit("input", []);
      this.$emit("change", [])
      if (province) {
        const response = await city(province.value );
        if (response && response.data) {
          this.cityList = response.data.map((item, i) => {
            return {
              name: item.name,
              value: item.id,
            };
          });
        }
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AddressSelect/City.vue